import { BulkExecutionError } from './../models/bulk-execution-error.model';
import { AuthService } from './auth.service';
import { Broker } from './../models/broker.model';
import { UtilsService } from 'src/app/services/utils.service';
import { HttpClient } from '@angular/common/http';
import { SortConfiguration } from './../components/generics/data-table/data-table.component';
import { Injectable } from '@angular/core';
import { ID } from '../models/ID.model';

@Injectable({
    providedIn: 'root'
})
export class BrokersService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService,
        private authService: AuthService
    ) { }

    getBrokers(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/agentes';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        const user = this.authService.getUser();
        if (user?.tipo === 'OFICINA') {
            params['id-oficina'] = user.oficina?.id;
        }
        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));
        return this.http.get<Broker[]>(url, { headers, observe: 'response', params });
    }

    deleteBroker(brokerId: ID) {
        return this.http.delete(`/agentes/${brokerId}`);
    }

    getBrokerById(id: ID) {
        return this.http.get<Broker>(`/agentes/${id}`);
    }

    createBroker(broker: Broker) {
        return this.http.post<Broker>(`/agentes`, broker);
    }

    editBroker(broker: Broker) {
        return this.http.put<Broker>(`/agentes/${broker.id}`, broker);
    }

    bulkLoad(brokers: Broker[]) {
        return this.http.post<BulkExecutionError[]>(`/agentes/creacion-masiva`, brokers);
    }
}
